import { useEffect } from "react";
import NProgress from "nprogress";
import { useLocation, useNavigate } from "react-router-dom";

type Props = {
    children: JSX.Element;
};

function AuthRouter({ children }: Props): JSX.Element {
    useEffect(() => {
        NProgress.start();
        NProgress.done();
    }, []);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        
        const uidEntity = localStorage.getItem("Uid_Entitie_User");

        if (uidEntity === null) {
            navigate("/");
        }

        
        const isAuthRoute =
            location.pathname.split("/").slice(1).join("/") ===
            "unauthorizedaccess";

        const authorized = localStorage.getItem("authorized");

        if (authorized && !isAuthRoute) {
            navigate("/unauthorizedaccess");
        }
    });

    return children;
}

export default AuthRouter;
